import React, { Component } from "react";
import { generic_get_api } from "api/generic_api";
import { SKU_METADATA, SKU_CATEGORIES } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { Placeholder } from 'react-bootstrap';

class SkuMetadata extends Component {

    constructor(props) {
        super(props);

        const locationState = this.props.location?.state || {};

        this.state = {
            seller_sku: locationState.seller_sku || '',
            asin: locationState.asin || '',
            fn_sku: locationState.fn_sku || '',
            history_list: [],
            loading: true,
        };
    }

    fetchHistory() {
        this.setState({ loading: true });

        generic_get_api(SKU_METADATA, { seller_id: 'SELF', seller_sku: this.state.seller_sku })
        .then(
            data => {
                const sorted = data.sort((a, b) => b.version - a.version);
                this.setState({
                    history_list: sorted,
                    loading: false,
                });
            }
        )
        .catch(error => {
            this.setState({ loading: false });
        });
    }

    formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    getCategoryLabel(value) {
        const cat = SKU_CATEGORIES.find(c => c.value === value);
        return cat ? cat.label : value || '—';
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, { 'data_1': 'sku_metadata' });
        if (this.state.seller_sku) {
            this.fetchHistory();
        }
    }

    render() {
        const { seller_sku, asin, fn_sku, history_list, loading } = this.state;

        return (
            <div class="container mt-4" style={{ maxWidth: '1100px' }}>
                <a href="#" class="text-muted small" onClick={(e) => { e.preventDefault(); this.props.history.push('/amz/sku_metadata_list'); }}>
                    <i class="fa-solid fa-arrow-left me-1"></i> Back to SKU List
                </a>

                <h4 class="mt-3 mb-1">SKU History</h4>

                <div class="mb-4">
                    <div class="fw-semibold">{seller_sku}</div>
                    {asin && <div class="text-muted small">ASIN: {asin}</div>}
                    {fn_sku && <div class="text-muted small">FN SKU: {fn_sku}</div>}
                </div>

                {loading &&
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={12} size="lg" className="mb-2" />
                        <Placeholder xs={12} size="lg" className="mb-2" />
                        <Placeholder xs={12} size="lg" className="mb-2" />
                    </Placeholder>
                }

                {!loading && history_list.length === 0 &&
                    <div class="text-muted mt-3">No history found.</div>
                }

                {!loading && history_list.length > 0 &&
                    <div class="small border rounded py-3" style={{ overflow: 'hidden' }}>
                        <div class="row fw-bold border-bottom pb-2 px-3">
                            <div class="col-auto">&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <div class="col-1">Version</div>
                            <div class="col-2">Effective Date</div>
                            <div class="col-1">COGS</div>
                            <div class="col-2">Category</div>
                            <div class="col-4">Product Name</div>
                            <div class="col-1"></div>
                        </div>
                        {history_list.map((entry, idx) => (
                            <div class="row py-2 px-3 border-bottom align-items-center" style={idx % 2 === 0 ? { backgroundColor: '#eef4f1' } : {}} key={entry.version}>
                                <div class="col-auto">
                                    {entry.is_active
                                        ? <i class="fa-solid fa-eye" style={{ color: 'hsl(152, 69%, 31%)' }}></i>
                                        : <i class="fa-solid fa-eye" style={{ color: '#c73110' }}></i>
                                    }
                                </div>
                                <div class="col-1">
                                    {idx === 0
                                        ? <><span>{entry.version}</span> <span class="badge bg-primary ms-1">Current</span></>
                                        : entry.version
                                    }
                                </div>
                                <div class="col-2">{this.formatDate(entry.modified_at)}</div>
                                <div class="col-1">{entry.cost != null ? '$' + entry.cost.toFixed(2) : <span class="text-muted">—</span>}</div>
                                <div class="col-2">{this.getCategoryLabel(entry.category)}</div>
                                <div class="col-4">{entry.product_name || <span class="text-muted">—</span>}</div>
                                <div class="col-1">
                                    <button class="btn btn-sm btn-outline-secondary">Edit</button>
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </div>
        );
    }
}

export default SkuMetadata;
